const trivial = async () => null;
export const optimistic = (onValidate = trivial) => {
    let queue = Promise.resolve();
    return (store) => {
        store.subscribe((value) => {
            let cancel = false;
            const handler = async () => {
                if (cancel) {
                    return;
                }
                const validated = await onValidate(value);
                if (!cancel && validated !== null) {
                    store.set(validated);
                }
            };
            queue = queue.then(handler);
            return () => {
                cancel = true;
            };
        });
        return store;
    };
};
//# sourceMappingURL=optimistic.js.map